exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "carpenter-edit {\n  display: block;\n  margin-bottom: 20px;\n}", ""]);

// exports
